import {
  MARKET_REPORT_REQUEST,
  MARKET_REPORT_REQUEST_FAILED,
  MARKET_REPORT_REQUEST_SUCCESS,
  ReportsActionsTypes,
  ReportsState,
  MONTHLY_REPORT_REQUEST,
  MONTHLY_REPORT_REQUEST_FAILED,
  MONTHLY_REPORT_REQUEST_SUCCESS,
} from '../types/reports';

const initialState: ReportsState = {
  marketReport: [],
  total: 0,
  error: '',
  loading: false,
  monthlyReport: null,
  monthlyReportLoading: false,
  monthlyReportError: '',
};

export default function ReportsReducer(
  state = initialState,
  action: ReportsActionsTypes,
): any {
  switch (action.type) {
    case MARKET_REPORT_REQUEST: {
      return {
        ...state,
        error: '',
        loading: true,
      };
    }

    case MARKET_REPORT_REQUEST_SUCCESS: {
      return {
        ...state,
        marketReport: action.payload.marketReport,
        total: action.payload.total,
        error: '',
        loading: false,
      };
    }

    case MARKET_REPORT_REQUEST_FAILED: {
      return {
        ...state,
        error: action.payload.message,
        loading: false,
      };
    }

    case MONTHLY_REPORT_REQUEST: {
      return {
        ...state,
        monthlyReportError: '',
        monthlyReportLoading: true,
      };
    }

    case MONTHLY_REPORT_REQUEST_SUCCESS: {
      return {
        ...state,
        monthlyReport: action.payload,
        monthlyReportError: '',
        monthlyReportLoading: false,
      };
    }

    case MONTHLY_REPORT_REQUEST_FAILED: {
      return {
        ...state,
        monthlyReportError: action.payload.message,
        monthlyReportLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}
